var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCounter = function SvgCounter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#06B6D4",
    fillRule: "evenodd",
    d: "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 1 0 0-1.5zm6.04 16.5.5-1.5h6.42l.5 1.5zm7.46-12a.75.75 0 1 0-1.5 0v6a.75.75 0 1 0 1.5 0zm-3 2.25a.75.75 0 1 0-1.5 0v3.75a.75.75 0 1 0 1.5 0zm-3 2.25a.75.75 0 1 0-1.5 0v1.5a.75.75 0 1 0 1.5 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCounter;